import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  bgColor?: 'cream' | 'sage' | 'forest' | 'white';
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  bgColor = 'white',
  id
}: SectionWrapperProps) {
  const bgColors = {
    cream: 'bg-brand-cream',
    sage: 'bg-brand-sage',
    forest: 'bg-brand-forest text-white',
    white: 'bg-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-6 ${bgColors[bgColor]} ${className}`} data-id="element-146">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-[800px] mx-auto w-full" data-id="element-147">
        {children}
      </motion.div>
    </section>;
}